var $6734626b878452f3$exports = {};
$6734626b878452f3$exports = {
    "info": `Info`,
    "negative": `Feil`,
    "positive": `Vellykket`
};


export {$6734626b878452f3$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
